import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { EMPTY, Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';

/**
 * Preloads routes marked with data.preload only when the browser is idle.
 * Other features remain lazy until navigation requests them.
 */
@Injectable({ providedIn: 'root' })
export class IdlePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<unknown>): Observable<unknown> {
    if (route.data?.['preload'] !== true) return EMPTY;
    return this.whenIdle().pipe(mergeMap(() => load()));
  }

  private whenIdle(): Observable<void> {
    return new Observable<void>(subscriber => {
      const requestIdleCallback = (window as unknown as { requestIdleCallback?: (cb: () => void, opts?: { timeout: number }) => number }).requestIdleCallback;
      if (typeof requestIdleCallback === 'function') {
        const handle = requestIdleCallback(() => {
          subscriber.next();
          subscriber.complete();
        }, { timeout: 5000 });
        return () => (window as unknown as { cancelIdleCallback?: (h: number) => void }).cancelIdleCallback?.(handle);
      }
      const timeoutId = setTimeout(() => {
        subscriber.next();
        subscriber.complete();
      }, 3000);
      return () => clearTimeout(timeoutId);
    });
  }
}
